export default "__VITE_ASSET__BYt77R2y__"